module.exports = __webpack_public_path__ + "img/6dfc971.png";